import * as React from "react";
import {Option} from "ts-option";
import {FormGroupProps} from "../../../common/props/FormGroupProps";
import {PlaceholderProps} from "../../../common/props/PlaceholderProps";
import SelectAssetCategory from "../../../assetCategory/SelectAssetCategory";
import DictionaryItem from "../../../../model/dictionary/DictionaryItem";
import FormGroup from "../../../../hiberUiKit/src/molecules/FormGroup/FormGroup";

type Props = FormGroupProps<string> & PlaceholderProps;

/**
 * Select asset category form view group.
 */
export default class SelectAssetCategoryFormGroup extends React.PureComponent <Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}
					   customClass={"c-asset-category-select"}>
				<SelectAssetCategory placeholder={this.props.placeholder}
									 selectedId={this.props.field.getOptionalValue()}
									 onChanged={this.onChange}/>
			</FormGroup>
		);
	}

	/**
	 * Callback on changed asset category
	 * @param data
	 */
	onChange(data: Option<DictionaryItem>) {
		this.props.onChange(this.props.field.updateValue(data.map(ac => ac.id)))
	}
}
